import { useContext } from "react";

import DialogCustom from "components/DesignComponents/DialogCustom";
import TutorialContext from "context/tutorial/tutorialContext";

import CompanyFilterContent from "./CompanyFilterContent";
import { CompanyFilterContext } from "./CompanyFilterState";

const FilterMobile = () => {
    const { isTutorialActive, setTutorialOpen } = useContext(TutorialContext);
    const { isDialogOpen, closeDialog } = useContext(CompanyFilterContext);

    return (
        <DialogCustom
            noPadding
            open={isDialogOpen}
            close={closeDialog}
            slotProps={{
                transition: {
                    onEntered: () => isTutorialActive && setTutorialOpen(true)
                }
            }}
        >
            <CompanyFilterContent close={closeDialog} />
        </DialogCustom>
    );
};

export default FilterMobile;
